/**
 * Amber "bQuest Preferred" pill (Features 083 + 096).
 * Shown on curated Preferred Provider cards everywhere they render.
 */

import { Check } from 'lucide-react';

export function PreferredBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-[#fbecca] px-2 py-0.5 text-xs font-medium text-[#8a6a16]">
      <Check className="w-3 h-3" aria-hidden="true" />
      bQuest Preferred
    </span>
  );
}
